<template>
    <div>
        <label for="month" class="vs-input--label">
            {{ label }}
        </label>
        <datepicker
            v-model="date"
            id="month"
            :format="dateFormat"
            :minimumView="'month'"
            :maximumView="'month'"
        />
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Datepicker,
  },
  props: {
    value: {
      type: null,
      required: false,
      default: () => null,
    },
    label: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      date: null,
      dateFormat: 'MMMM yyyy'
    }
  },
  mounted () {
    this.date = this.value
  },
  watch: {
    date: {
      immediate: false,
      handler (date) {
        this.$emit('input', date)
      }
    }
  },
}
</script>
